import LegalPolicyContent from "./LegalPolicyContent";

export default LegalPolicyContent;
